/**
 * Single source of truth for the running build's version string.
 *
 * `VITE_APP_VERSION` is injected at build time by `vite.config.ts`'s
 * `define` block, derived from `package.json`. Same value at runtime
 * regardless of mode (dev/prod). Use this constant everywhere — auth
 * footers, Settings → Instalación, Sentry release tags, version-check
 * comparisons — so a single rename in `vite.config.ts` flows through
 * the whole app.
 *
 * The legacy pattern of importing `package.json` directly was deprecated
 * 2026-05-10: same value, but two patterns to maintain made it easy to
 * forget one place during refactors.
 */
export const APP_VERSION = import.meta.env.VITE_APP_VERSION as string
